import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/auth/PrivateRoute';
import { MainLayout } from './components/layout/MainLayout';
import { Apps } from './pages/Apps';
import { AppParameters } from './pages/AppParameters';
import { Templates } from './pages/Templates';
import { Presets } from './pages/Presets';
import { Landings } from './pages/Landings';
import { Logs } from './pages/Logs';
import { GrafanaLogs } from './pages/GrafanaLogs';
import { Profile } from './pages/Profile';
import './i18n';

function App() {
  return (
    <Routes>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Navigate to="/apps" replace />} />
          <Route path="apps" element={<Apps />} />
          <Route path="apps/create" element={<Apps />} />
          <Route path="apps/edit/:id" element={<Apps />} />
          <Route path="apps/:id/parameters" element={<AppParameters />} />
          <Route path="templates" element={<Templates />} />
          <Route path="templates/create" element={<Templates />} />
          <Route path="templates/edit/:id" element={<Templates />} />
          <Route path="presets" element={<Presets />} />
          <Route path="landings" element={<Landings />} />
          <Route path="landings/create" element={<Landings />} />
          <Route path="landings/edit/:id" element={<Landings />} />
          <Route path="logs" element={<Logs />} />
          <Route path="grafana-logs" element={<GrafanaLogs />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Route>
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;